import { useMemo } from 'react';

export type FormatFn<T = unknown> = (value: T, key: string, data: Record<string, unknown>) => unknown;

export const useFormatQueryFields = <T extends Record<string, unknown>>(
  data: T,
  keys: string[],
  formatFn: FormatFn,
): T => {
  return useMemo(() => {
    if (!data) return data;
    const formatted: Record<string, unknown> = { ...data };
    keys.forEach((key) => {
      if (key in data) {
        formatted[key as string] = formatFn(data[key], key as string, data);
      }
    });
    return formatted as T;
  }, [data, keys, formatFn]);
};
